import { BaseResource as Resource } from '../defaults/resource'
import withMessages from './with-messages'

export default {
  mixins: [ withMessages ],
  mounted () {
    this.listen()
  },
  beforeDestroy () {
    this.unlisten()
  },
  methods: {
    handleMessages (e) {
      switch (e.data.event) {
        case 'cms:updateResources':
          return this.handleUpdateResources(e.data)
        case 'cms:updateResource':
          return this.handleUpdateResource(e.data)
        case 'cms:revertResource':
          return this.handleRevertResource(e.data)
        case 'cms:scrollToResource':
          return this.handleScrollToResource(e.data)
        default:
      }
    },
    handleRevertResource (data) {
      Resource.update({
        where: data.payload.id,
        data: {
          ...data.payload,
          dirty: false
        }
      })
      if (this.data.id === data.payload.id) {
        this.data = data.payload
      }
    },
    handleUpdateResource (data) {
      Resource.update({
        where: data.payload.resource.id,
        data: data.payload.resource
      })
    },
    async handleUpdateResources (data) {
      const resources = data.payload.resources.map(r => ({
        ...r,
        dirty: true
      }))

      await Resource.insertOrUpdate({
        data: resources
      })
    },
    async handleScrollToResource (data) {
      Resource.update({
        where: r => r.highlighted,
        data: { highlighted: false }
      })

      Resource.update({
        where: data.payload.resource.id,
        data: { highlighted: true }
      })

      const node = document.querySelector(`[data-resource="${data.payload.resource.id}"]`)
      window.scrollTo({
        top: node.offsetTop,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
}
